import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { Button } from "./ui/button";

export function LandingNav() {
  const [open, setOpen] = useState(false);
  const links = [
    { href: "#how-it-works", label: "How It Works" },
    { href: "#pricing", label: "Pricing" },
    { href: "#faq", label: "FAQ" },
  ];
  return (
    <header className="sticky top-0 z-40 bg-background/85 backdrop-blur-md border-b border-border/50">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-3 md:py-4 flex items-center justify-between">
        <Logo size="xl" />
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/login"
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            data-testid="nav-login"
          >
            Login
          </Link>
          <Button asChild className="rounded-full px-6" data-testid="nav-cta-trial">
            <Link to="/signup">Start Free Trial</Link>
          </Button>
        </nav>
        <button
          className="md:hidden p-2 rounded-lg hover:bg-muted"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-border/50 bg-background">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a key={l.href} href={l.href} className="text-sm font-medium" onClick={() => setOpen(false)}>
                {l.label}
              </a>
            ))}
            <Link to="/login" className="text-sm font-medium" onClick={() => setOpen(false)}>
              Login
            </Link>
            <Button asChild className="rounded-full">
              <Link to="/signup" onClick={() => setOpen(false)}>Start Free Trial</Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
